import { styled } from 'styled-components'

export const Images = styled.div`
  margin-bottom: 50px;

  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export const ImageContent = styled.article`
  min-width: 250px;
  width: 250px;
  height: 250px;

  padding: 5px;
  background: #d5d8dc;
  border-radius: 10px;

  display: flex;
  flex-direction: column;
`

export const TextContent = styled.div`
  flex: 1;

  p {
    all: unset;
    color: auto;
    font-size: 10px;
    font-weight: bold;
    text-justify: distribute-all-lines;
  }
`

export const ImageButtons = styled.footer`
  height: 35px;

  display: flex;
  justify-content: space-between;

  main {
    height: 30px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;

    button {
      margin: 0;
    }
  }
`
